import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, redMui, rydeColors } from "@ryde/theme";

export const ProductionPreviewWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "production-preview",
  },
)`
  .production-preview__link {
    margin-inline: 4px;
  }

  .production-preview__label--red {
    color: ${redMui._600};
  }
`;

export const GeneralInfoBlock = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "general-info-block",
})`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  margin-inline-start: 10px;
`;

export const GeneralInfoTitleBlock = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "general-info-title-block",
})`
  font-size: 12px;
  color: ${blueGreyMui._500};
`;

export const GeneralInfoTextBlock = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "general-info-text-block",
})`
  font-size: 12px;
  font-weight: 700;
  color: ${rydeColors.black};
`;
export const GeneralInfoNumberBlock = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "general-info-number-block",
})`
  font-size: 12px;
  color: ${rydeColors.previewNumberColor};
`;

export const ProductionPreviewSummaryStyled = styled.span.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "production-preview-summary-styled",
  },
)`
  margin-top: 5px;
  margin-bottom: 8px;
  display: grid;
  grid-template-columns: max-content auto;
  grid-row-gap: 4px;
  .summary_item_title {
    font-size: 12px;
    color: ${blueGreyMui._900};
    padding-inline-end: 10px;
  }
  .summary_item_info {
    font-size: 12px;
    font-weight: 700;
    color: ${rydeColors.black};
  }
`;
